import AnimationClip from '../AnimationClip';
import Point from '../../../Utility/Point';
import GameObject from '../../../GameObject/GameObject';
import PIXIRenderer from '../../Render/PIXIRenderer';
import Element from '../../../Prototype/UI/Element';
import Field, { CropParticles } from '../../../Prototype/World/Field';
import { FieldHarvest } from './FieldHarvest';
import Game from '../../../Game';
import { WorldDataHelper } from '../../../Utility/WorldDataHelper';
import HarvestCrop from '../../../Prefabs/UI/Harvest/HarvestCrop';
import { delay } from '../../../Utility/Task/TaskQueue';
import { Random } from '../../../Utility/Random';
import { IGameState } from '../../../State/Game/IGameState';
import { getHighestLevelCompleted } from 'State/Player/PlayerLevelHelper';
import WorldHUDHandler from 'System/UI/HUD/WorldHUDHandler';

export class HarvestOffWorldCrops extends AnimationClip {
    public rewardContainer: GameObject;
    public fieldDelay: number = 75;
    public worldDelayMultiplier: number = 200;
    public startDelay: number = 0;

    public *execute(gameObject: GameObject): IterableIterator<number> {
        let rewards: Element[] = [];
        const destination: Point = Field.getDestinationPoint();
        this.rewardContainer = GameObject.findFirstByName(WorldHUDHandler.CROP_CONTAINER);

        const state: IGameState = Game.store.getState();
        const currentWorldFields = WorldDataHelper.getAllFieldsData(state.worldState.worldNumber);
        const currentUnlockedFields = currentWorldFields.filter(
            fieldData => state.playerState.fields.indexOf(`${fieldData.id}_0`) !== -1
        );
        const worldDelay = this.worldDelayMultiplier * currentUnlockedFields.length;

        for (let worldNumber = 1; worldNumber <= state.playerState.maxWorld; worldNumber++) {
            if (worldNumber === state.worldState.worldNumber) continue;

            const distanceFromCurrentWorld: number = Math.abs(state.worldState.worldNumber - worldNumber);

            const viewport = PIXIRenderer.mapViewport;
            const center: Point = new Point(
                viewport.screenWidth / 2 - viewport.position.x,
                viewport.screenHeight / 2 - viewport.position.y
            );

            const fieldData = WorldDataHelper.getAllFieldsData(worldNumber);

            const total = fieldData.reduce((acc, field, fieldIndex) => {
                return (
                    acc +
                    WorldDataHelper.getCropModels(worldNumber, fieldIndex).length *
                        field.cropSettings.harvestSettings.count
                );
            }, 0);
            const maxSprites = 70;
            const k = Math.min(1, maxSprites / total);

            const highestLevelAchieved: number = getHighestLevelCompleted(state.playerState);
            fieldData.forEach((field, fieldIndex) => {
                if (field.requiredLevel[0] >= highestLevelAchieved) return;

                const offset: Point = new Point(
                    viewport.screenWidth * (worldNumber < state.worldState.worldNumber ? -1 : 1),
                    0
                );

                const models = WorldDataHelper.getCropModels(worldNumber, fieldIndex);

                models.slice(0, Math.floor(models.length * k)).forEach(() => {
                    offset.y = Random.int(0, PIXIRenderer.mapViewport.screenHeight) * Random.sign();

                    const delay: number = fieldIndex * this.fieldDelay + distanceFromCurrentWorld * worldDelay;

                    rewards = [
                        ...rewards,
                        ...FieldHarvest.createRewards(
                            Point.add(center, offset),
                            field.cropSettings.harvestSettings,
                            [...field.cropSettings.harvestSettings.icons, ...CropParticles],
                            delay
                        ),
                    ];
                });
            });

            rewards = rewards.filter(() => Random.sign() > 0);

            yield* delay(this.startDelay * currentUnlockedFields.length * 0.5);

            rewards.forEach((reward: HarvestCrop) => {
                this.rewardContainer.addChild(reward);
                reward.play(destination);
            });
        }
    }
}
